import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=1d581ecc&scoped=true&"
import script from "./Templates.ts?vue&type=script&lang=ts&"
export * from "./Templates.ts?vue&type=script&lang=ts&"
import style0 from "./templates.scss?vue&type=style&index=0&id=1d581ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d581ecc",
  null
  
)

export default component.exports